import { Message } from 'element-ui';
import bigDataLog from '@/utils/bigDataLog';

/*  验证数据是否被改动
    参数：object1: 标准数据     object2: 待验证数据
    返回结果：Boolean   true已改 false未改
*/
export const validationDataChange = (object1 = {}, object2 = {}) => {
    var isChange = false;
    var obj1 = JSON.parse(JSON.stringify(object1));
    var obj2 = JSON.parse(JSON.stringify(object2));
    function recursive(obj1, obj2) {
        for (var key in obj1) {
            if (obj1.hasOwnProperty(key)) {
                var item1 = obj1[key];
                var item2 = obj2[key];
                if ((item1 instanceof Array) && (item2 instanceof Array) && item1.length !== item2.length) {
                    isChange = true;
                    recursive(item1, item2);
                } else if (typeof item1 !== 'object' && item2 === undefined) {
                    isChange = true;
                } else if (typeof item1 === 'object' && item2 === undefined) {
                    isChange = true;
                } else if (typeof item1 === 'object' && typeof item2 === 'object') {
                    recursive(item1, item2);
                } else if (item1 === undefined && item2) {
                    isChange = true;
                } else if (item1 !== item2) {
                    isChange = true;
                }
            }
        }
    }
    recursive(obj1, obj2);
    return isChange;
};

// 公共方法部分
// 校验输入正负数， 保留2位小数 传来的需要是string类型
export function plusOrMinus(values) {
    let newValue;
    if (!(/[^0-9.-]/g.test(values))) {
        newValue = values.replace(/[^\-\d.]/g, '').replace(/\b(0+){2,}/g, '0').replace(/\-{2,}/g, '-')
            .replace(/^\./g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
        if (newValue.toString().indexOf('.') > 0 && Number(newValue.toString().split('.')[1].length) > 2) {
            newValue = parseInt(parseFloat(newValue) * 100) / 100;
        }
        if ((newValue.toString().split('-').length - 1) > 1) {
            newValue = parseFloat(newValue) || '';
        };
        if ((newValue.toString().split('-').length) > 1 && newValue.toString().split('-')[0].length > 0) {
            newValue = parseFloat(newValue) || '';
        };
        if (newValue.toString().length > 1 && (newValue.toString().charAt(0) === '0' ||
            (newValue.toString().length > 2 && newValue.toString().charAt(0) === '-' && newValue.toString().charAt(1) === '0' &&
                newValue.toString().charAt(2) !== '.')) && newValue.toString().indexOf('.') < 1) {
            newValue = parseFloat(newValue) || '';
        };
        // 判断整数位最多为9位
        if (newValue.toString().indexOf('.') > 0 && Number(newValue.toString().split('.')[0].length) > 9) {
            newValue = newValue.toString().substring(0, 9) + '.' + newValue.toString().split('.')[1];
        } else if (newValue.toString().indexOf('.') < 0 && Number(newValue.toString().split('.')[0].length) > 9) {
            newValue = newValue.toString().substring(0, 9);
        };
    } else {
        newValue = values.replace(/[^0-9.-]/g, '');
    };
    return newValue;
}

/**
 * description 检查指定扩展名文件
 * @param {string} filename 文件名
 * @param {array} extensions 扩展名数组
 */
export function checkExtensions(filename, extensions = []) {
    const extension = filename.split('.').pop().toLowerCase();
    return extensions.includes(extension);
}

/**
 * description 预览文件
 * @param {string} url 文件地址
 */
export function previewFile(url) {
    const viewUrl = 'https://view.officeapps.live.com/op/view.aspx?src=';
    window.open(viewUrl + encodeURIComponent(url));
}

/**
 * @description 根据字典数据获取下拉框选项
 * @param dictData 字典数据
 */
export function getSelectOptionsByDict(dictData) {
    return Object.keys(dictData).map(key => {
        return { label: dictData[key], value: key };
    });
}
/**
 * @description 根据字典数据获取展示的文本
 * @param dictData 字典数据
 * @param code
 */
export function getTextByDict(dictData, code) {
    return dictData && dictData !== 'undefined' ? typeof dictData === 'string' ? JSON.parse(dictData)[code] : dictData[code] : '';
}

/**
 * 从对象中删除指定的键及其对应的值。
 *
 * @param {Object} obj - 要删除键的对象。
 * @param {Array<string>} keys - 要删除的键的数组。
 * @returns {Object} 返回删除了指定键后的对象。
 */
export const deleteKeysFromObject = (obj, keys) => {
    keys.map(key => {
        delete obj[key];
    });
    return obj;
};

/**
 * 合并两个对象中具有相同键的属性值，将源对象（obj）中的属性值覆盖到目标对象（data）中。
 *
 * @param {Object} obj - 源对象，包含要合并的属性值。
 * @param {Object} data - 目标对象，用于存储合并后的属性值。
 * @returns {Object} 返回更新后的目标对象。
 */
export const mergeMatchedKeys = (obj, data) => {
    data = JSON.parse(JSON.stringify(data));
    obj = JSON.parse(JSON.stringify(obj));
    Object.keys(obj).forEach(key => {
        Object.keys(data).forEach(subKey => {
            if (key === subKey) {
                data[key] = obj[subKey];
            }
        });
    });
    return data;
};

/**
 * 根据对象的属性值获取其在数组中的索引
 *
 * @param array 数组 - 包含对象的数组
 * @param propertyName 字符串 - 要检查的属性名
 * @param targetValue 任意类型 - 目标属性值
 * @returns {number|undefined} 返回匹配属性值的对象在数组中的索引，如果未找到则返回undefined
 */
export const getIndexByPropertyValue = function (array, propertyName, targetValue) {
    for (let index = 0; index < array.length; index++) {
        const obj = array[index];
        if (obj.hasOwnProperty(propertyName) && obj[propertyName] === targetValue) {
            return index;
        }
    }
};

/**
* 检查对象数组数据是否被改动
* @param {Array<Object>} originalData - 原数据。
* @param {Array<Object>} targetData - 目标数据。
* @param {String} findField - 通过该指定字段去匹配目标数据中和原数据匹配的对象验证数据是否被改动,没传则通过索按引顺序匹配。
* @returns {Boolean} true已改 false未改。
*/
export const checkDataChange = function (
    originalData = [],
    targetData = [],
    findField = ''
) {
    let isModified = false;
    // 如果原数据和目标数据数量不等，则发生了修改
    originalData.length !== targetData.length && (isModified = true);
    // 遍历目标数据中的每个对象
    for (let index = 0; index < originalData.length; index++) {
        const originalItem = originalData[index] || [];

        // 查找目标数据中的对应对象
        const targetItem = findField ? targetData.find(item => item[findField] === targetItem[findField]) : targetData[index];

        // 如果没有找到对应的原数据项，则跳过
        !targetItem && (isModified = true);

        // 验证数据是否被改动
        !isModified && (isModified = validationDataChange(originalItem, targetItem));

        if (isModified) {
            break;
        }
    }
    return isModified;
};

/**
 * description 检查图片文件
 * @param {string} filename 文件名
 */
export function isImageFile(filename) {
    const extensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
    const extension = filename.split('.').pop().toLowerCase();
    return extensions.includes(extension);
}

/**
 * description 下载图片
 * @param {string} imgsrc 图片地址
 * @param {string} name 图片名称
 */
export function downloadImage(imgsrc, name = 'photo') {
    // 确保 imgsrc 是一个有效的URL
    if (!imgsrc || typeof imgsrc !== 'string' || !imgsrc.startsWith('http')) {
        // eslint-disable-next-line no-console
        console.error('Invalid image source');
        return;
    }

    var image = new Image();
    image.crossOrigin = 'anonymous';
    image.onload = function () {
        var canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext('2d');
        context.drawImage(image, 0, 0, image.width, image.height);

        try {
            var url = canvas.toDataURL('image/png');
            var a = document.createElement('a');
            a.download = name;
            a.href = url;
            a.style.display = 'none'; // 防止元素在页面上可见
            document.body.appendChild(a); // 添加到DOM中，以便可以触发点击事件
            a.click(); // 触发点击事件
            document.body.removeChild(a); // 从DOM中移除
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Failed to download image:', error);
        }
    };

    image.onerror = function () {
        // eslint-disable-next-line no-console
        console.error('Failed to load image:', imgsrc);
    };

    image.src = imgsrc;
}

/**
 * description 下载文件
 * @param {string} path 文件路径
 * @param {string} filename 文件名称
 */
export const download = function (path, filename) {
    const x = new XMLHttpRequest();
    x.open('GET', path, true);
    x.responseType = 'blob';
    x.onload = function (e) {
        const url = window.URL.createObjectURL(x.response);
        const a = document.createElement('a');
        a.href = url;
        const index = path.lastIndexOf('/');
        a.download = filename || path.substring(index + 1);
        a.click();
        document.body.removeChild(a);
    };
    x.send();
};
